import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { IdCard, Trophy } from 'lucide-react';

import LoadingPage from '@/components/common/LoadingPage';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import GenerateCardLinkDialog from '@/app/card/GenerateCardLinkDialog';

import { useUser } from '@/data/user';

const UserViewPage = () => {
  const params = useParams();
  const user = useUser(params.id);

  const [isGenerateCardLinkDialogOpen, setIsGenerateCardLinkDialogOpen] =
    useState(false);

  if (user.isLoading && !user.data) {
    return <LoadingPage />;
  }

  return (
    <>
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/user">Users</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>
              {user.data.firstname} {user.data.lastname}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card>
        <CardContent className="p-8">
          <div className="flex justify-between">
            <div className="flex gap-8">
              <Avatar className="w-40 h-40">
                <AvatarImage src={user.data.avatar} />
                <AvatarFallback className="text-4xl font-bold">
                  {user.data.firstname.charAt(0)}
                  {user.data.lastname.charAt(0)}
                </AvatarFallback>
              </Avatar>
              <div>
                <h1 className="text-2xl font-bold">
                  {user.data.firstname} {user.data.lastname}
                </h1>
                <p className="text-muted-foreground">{user.data.email}</p>
                <p className="text-muted-foreground">{user.data.phone}</p>
              </div>
            </div>
            <div className="flex gap-4">
              {user.data?.coach?.id && (
                <Link to={`/coach/${user.data.coach.id}`}>
                  <Button variant="outline">
                    <Trophy className="w-4 h-4 mr-2" />
                    View Coach
                  </Button>
                </Link>
              )}
              <Button
                variant="outline"
                className="gap-2"
                onClick={() => setIsGenerateCardLinkDialogOpen(true)}
              >
                ProFound Card
                <IdCard />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
      {isGenerateCardLinkDialogOpen && (
        <GenerateCardLinkDialog
          onClose={() => setIsGenerateCardLinkDialogOpen(false)}
        />
      )}
    </>
  );
};

export default UserViewPage;
